import { useEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import miLogo from '../../../assets/mi-logo.png';

const MichiganPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'RSS - Michigan Orders';
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = miLogo;
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100dvh',
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        backgroundImage: {
          md: 'linear-gradient(90deg, var(--mi-primary) 0%, var(--mi-secondary) 100%)',
          xs: 'linear-gradient(180deg, var(--mi-primary) 0%, var(--mi-secondary) 100%)',
        },
      }}
    >
      <Box
        component={Link}
        to='/mi'
        sx={{
          display: 'inline-flex',
          width: {
            xs: 140,
            sm: 180,
            md: 200,
          },
          height: 'auto',
          marginTop: 3,
          marginBottom: { xs: 0, md: 10 },
        }}
      >
        <Box
          component='img'
          src={miLogo}
          alt={t('alt.michigan_lottery_logo')}
          sx={{
            display: 'block',
            width: '100%',
            height: 'auto',
          }}
        />
      </Box>

      <Outlet />
    </Box>
  );
};

export default MichiganPage;
